export default function formatTime(t: number, showMilliseconds: boolean) {
    var hours = Math.floor(t / 60 / 60),
        minutes = Math.floor((t / 60) % 60),
        seconds = Math.floor(t % 60),
        millisecs = showMilliseconds
            ? Number((t - Math.floor(t)).toFixed(1)) * 10
            : 0,
        theTime =
            (hours < 1 ? '' : hours + ':') +
            (minutes < 10 ? '0' + minutes : minutes) +
            ':' +
            (seconds < 10 ? '0' + seconds : seconds) +
            (showMilliseconds ? '.' + millisecs : '')

    return theTime
}
